import React from "react";

export const Footer = () => {
  return (
    <div
      style={{
        position: "fixed",
        padding: "0 3em",
        bottom: 0,
        width: "100%",
        backgroundColor: "white",
        transform: "translateX(-32px)",
        textAlign: "center",
        borderTop: "1px solid #ccc",
        zIndex: 1000,
      }}
    >
      <p style={{ fontSize: "10px", color: "#808080", marginTop: "1em" }}>
        Sirago Underwriting Managers (Pty) Ltd is an Authorised Financial
        Services Provider (FSP: 4710) underwriting Agency for GENRIC Insurance
        Company Limited (FSP: 43638). GENRIC is an authorised Financial Services
        Provider and licensed non-life insurer and a member of the Old Mutual
        Group.
      </p>
    </div>
  );
};
